// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .search-btn {
    margin-bottom: 1.5%;
  }
}
.search-btn {
  max-width: 214px;
}

@media screen and (max-width: 575px) {
  .search-btn {
    max-width: 100%;
  }
}
.table_custom_grey_scroll {
  max-height: 500px;
  overflow: auto;
}

.table_custom_grey_scroll {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.table_custom_grey_scroll::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}
.table_custom_grey_scroll::-webkit-scrollbar-track {
  background: rgba(180, 178, 178, 0.4509803922);
  border-radius: 10px;
}
.table_custom_grey_scroll::-webkit-scrollbar-thumb {
  background: #808080;
  border-radius: 10px;
}
.table_custom_grey_scroll::-webkit-scrollbar-thumb:hover {
  background: #808080;
  border-radius: 10px;
}

.dateRangeBtn {
  width: 180.5px;
  height: 36px;
  background-color: #4c00ef;
}

@media screen and (max-width: 575px) {
  .dateRangeBtn {
    width: 100%;
    height: 36px;
    background-color: #4c00ef;
  }
}
@media screen and (max-width: 1440px) {
  .dateRangeBtn {
    font-size: 10px;
  }
  .invoicedownload {
    font-size: 10px;
    padding: 9px 12px;
  }
}
.download_button {
  width: 170px;
  height: 38px;
  background-color: #4c00ef;
}

.select-item {
  width: 200px;
  z-index: 999;
}

@media screen and (max-width: 575px) {
  .select-item {
    max-width: 100%;
    width: auto;
  }
}
.select-item-transction {
  width: 250px;
  z-index: 999;
}`, "",{"version":3,"sources":["webpack://./src/styles/monetray.scss"],"names":[],"mappings":"AAAA;EAKI;IACI,mBAAA;EAHN;AACF;AAMA;EACI,gBAAA;AAJJ;;AAOA;EACI;IACA,eAAA;EAJF;AACF;AAQA;EACI,iBAAA;EACA,cAAA;AANJ;;AASA;EAME,UAAA;EAMA,WAAA;EAMA,oBAAA;AArBF;AAIE;EACE,UAAA;EACA,mBAAA;AAFJ;AAME;EACE,6CAAA;EACA,mBAAA;AAJJ;AAQE;EACE,mBAAA;EACA,mBAAA;AANJ;AAUE;EACE,mBAAA;EACA,mBAAA;AARJ;;AAYA;EACI,cAAA;EACA,YAAA;EACA,yBAAA;AATJ;;AAYA;EACI;IACA,WAAA;IACA,YAAA;IACA,yBAAA;EATF;AACF;AAWA;EACG;IACC,eAAA;EATF;EAWC;IACC,eAAA;IACA,iBAAA;EATF;AACF;AAaA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,YAAA;AAXJ;;AAaA;EACI;IACI,eAAA;IACA,WAAA;EAVN;AACF;AAcA;EACI,YAAA;EACA,YAAA;AAZJ","sourcesContent":["@media screen and (max-width: 991px){\n    .date-range-modal{\n        // margin-top: 1.5%;\n        // margin-bottom: 1.5%;\n    }\n    .search-btn{\n        margin-bottom: 1.5%;     \n    }\n}\n\n.search-btn{\n    max-width: 214px;\n}\n\n@media screen and (max-width:575px) {\n    .search-btn{\n    max-width: 100%;\n}   \n}\n\n\n.table_custom_grey_scroll{\n    max-height: 500px;\n    overflow: auto;\n}\n// Inside the component or in a separate CSS file\n.table_custom_grey_scroll {\n  &::-webkit-scrollbar {\n    width: 5px;\n    border-radius: 10px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #b4b2b273;\n    border-radius: 10px;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: #808080;\n    border-radius: 10px;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: #808080;\n    border-radius: 10px;\n  }\n}\n\n.dateRangeBtn{\n    width: 180.5px;\n    height: 36px;\n    background-color: #4c00ef;\n}\n\n@media screen and (max-width:575px) {\n    .dateRangeBtn{\n    width: 100%;\n    height: 36px;\n    background-color: #4c00ef;\n   }\n}\n@media screen and (max-width:1440px) {\n   .dateRangeBtn{\n    font-size: 10px;\n   }\n   .invoicedownload{\n    font-size: 10px;\n    padding: 9px 12px;\n   }\n    \n}\n\n.download_button{\n    width: 170px;\n    height: 38px;\n    background-color: #4c00ef;\n}\n\n.select-item{\n    width: 200px;\n    z-index: 999;\n}\n@media screen and (max-width:575px) {\n    .select-item{\n        max-width: 100%;\n        width: auto;\n    }\n\n}\n\n.select-item-transction{\n    width: 250px;\n    z-index: 999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
